import { ITdlTypeaheadOption } from "@torre-labs/material";

import { CookieService } from "./CookieService";
import { CandidateTrackingUtm, ICandidateTrackingUtm } from "./DTOs/CandidateTrackingUtm";

class Service {
  private showFirstSignalDialogsKey = "showFirstSignalDialogs";
  private opportunitiesBenefitsKey = "opportunitiesBenefitsViewed";
  private onBoardingIdsKey = "onBoardingIds";
  private invitedCandidatesKey = "invitedCandidates";
  private trackingCodeKey = "trackingCode";
  private pendingShareDialogOpeningKey = "pendingShareDialogOpening";
  private utmsTracking = "utmsTracking";
  private communityTokenKey = "torre.community_token";

  public storeFirstSignalDialogPendingAction(payload: { signaledName: string }): void {
    sessionStorage.setItem(this.showFirstSignalDialogsKey, JSON.stringify(payload));
  }

  public storeCommunityToken(payload: string): void {
    CookieService.setCookie(this.communityTokenKey, payload, 30);
  }

  public extractFirstSignalDialogPendingAction(): { signaledName: string } | null {
    const stored = sessionStorage.getItem(this.showFirstSignalDialogsKey);
    sessionStorage.removeItem(this.showFirstSignalDialogsKey);

    return stored ? JSON.parse(stored) : null;
  }

  public storeTrackingCode(codeId: string): void {
    sessionStorage.setItem(this.trackingCodeKey, codeId);
  }

  public extractTrackingCode(): string | null {
    return sessionStorage.getItem(this.trackingCodeKey);
  }

  public storeUtmTracking(queryStringParams: ICandidateTrackingUtm): void {
    try {
      localStorage.setItem(this.utmsTracking, JSON.stringify(queryStringParams));
    } catch (error) {
      // tslint:disable-next-line:no-console
      console.error(error);
    }
  }

  public extractUtmTracking(): CandidateTrackingUtm | undefined {
    const stored = localStorage.getItem(this.utmsTracking);
    localStorage.removeItem(this.utmsTracking);

    return stored ? new CandidateTrackingUtm(JSON.parse(stored)) : undefined;
  }

  public storeOpportunitiesBenefitsViewed(): void {
    localStorage.setItem(this.opportunitiesBenefitsKey, "true");
  }

  public extractOpportunitiesBenefitsViewed(): boolean {
    const stored = localStorage.getItem(this.opportunitiesBenefitsKey);
    localStorage.removeItem(this.opportunitiesBenefitsKey);

    return !!stored;
  }

  public storeOnBoardingIds(ids: string[]): void {
    localStorage.setItem(this.onBoardingIdsKey, JSON.stringify(ids));
  }

  public extractOnBoardingIds(): string[] | undefined {
    const stored = localStorage.getItem(this.onBoardingIdsKey);
    localStorage.removeItem(this.onBoardingIdsKey);

    return stored ? JSON.parse(stored) : null;
  }

  public storeInvitedCandidates(candidates: ITdlTypeaheadOption[]): void {
    localStorage.setItem(this.invitedCandidatesKey, JSON.stringify(candidates));
  }

  public extractInvitedCandidates(): ITdlTypeaheadOption[] | undefined {
    const stored = localStorage.getItem(this.invitedCandidatesKey);
    localStorage.removeItem(this.invitedCandidatesKey);

    return stored ? JSON.parse(stored) : null;
  }

  public storePendingShareDialogOpening(): void {
    sessionStorage.setItem(this.pendingShareDialogOpeningKey, "true");
  }

  public extractPendingShareDialogOpening(): boolean {
    const stored = sessionStorage.getItem(this.pendingShareDialogOpeningKey);
    sessionStorage.removeItem(this.pendingShareDialogOpeningKey);

    return !!stored;
  }

  public storeVisitedURL(url: string): void {
    localStorage.setItem(url, "visited");
  }

  public getVisitedURL(url: string): string | null {
    return localStorage.getItem(url);
  }

  public storeFeatureRequested(feature: string): void {
    localStorage.setItem(`torre.feature.${feature}.status`, "requested");
  }

  public isFeatureRequested(feature: string): boolean {
    return localStorage.getItem(`torre.feature.${feature}.status`) === "requested";
  }

  public setItemLocalStorage(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public getItemLocalStorage(key: string): string | null {
    return localStorage.getItem(key);
  }

  public storeUserLocale(locale: string): void {
    localStorage.setItem("locale", locale);
  }
}

export const StorageService = new Service();
